import { useActiveAccountId } from '@frameio/shared/contexts';
import { useOpenInBrowserMutation } from '@frameio/shared/integrations/gql';
import { getV4WorkspaceURLFromIntegrations } from '@frameio/shared/routing/redirectToV4';
import type { MenuProps } from '@frameio/vapor';
import { Menu, MenuButton, MenuGroup } from '@frameio/vapor';
import { IconOpenIn } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/ContextMenuForIntegrations';

type Props = {
  ariaId?: string;
  minWidth?: string;
};

export const ContextMenuForIntegrations = ({
  ariaId,
  minWidth,
  ...props
}: Props &
  Pick<MenuProps, 'onRequestChange' | 'anchorElement' | 'anchorPosition'>) => {
  const accountId = useActiveAccountId();
  const url = getV4WorkspaceURLFromIntegrations(accountId);
  const [openInBrowser] = useOpenInBrowserMutation({
    context: { resolveWithUXP: true },
  });

  const handlePress = () => {
    openInBrowser({
      variables: {
        input: { url },
      },
    });
  };

  return (
    <Menu
      {...props}
      aria-describedby={ariaId}
      aria-labelledby={ariaId}
      content={
        <MenuGroup label={TEXT.menuTitle}>
          <MenuButton iconBefore={<IconOpenIn />} onPress={handlePress}>
            {TEXT.openInBrowser}
          </MenuButton>
        </MenuGroup>
      }
      hasRefocusEventOnClose={false}
      minWidth={minWidth}
    />
  );
};

TEXT.DEFINE({
  /** Menu item label to open workspace in a browser */
  openInBrowser: 'Open in browser',
  /** Menu group title for workspace actions */
  menuTitle: 'Workspace',
});
